export default __webpack_public_path__ + "static/media/ih-cr-error.5684375c.svg";